/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_DetectionInputs */

const en_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error Detection`)
};

const fr_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection des erreurs`)
};

const de_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlererkennung`)
};

const it_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento degli errori`)
};

const ru_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение ошибок`)
};

const es_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de errores`)
};

const zh_cn2_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误检测`)
};

const ja_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー検出`)
};

const hi_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि का पता लगाना`)
};

const pt_pt2_error_detection = /** @type {(inputs: Error_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de erro`)
};

/**
* | output |
* | --- |
* | "Error Detection" |
*
* @param {Error_DetectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_detection = /** @type {((inputs?: Error_DetectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_DetectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_detection(inputs)
	if (locale === "de") return de_error_detection(inputs)
	if (locale === "it") return it_error_detection(inputs)
	if (locale === "ru") return ru_error_detection(inputs)
	if (locale === "es") return es_error_detection(inputs)
	if (locale === "zh-CN") return zh_cn2_error_detection(inputs)
	if (locale === "ja") return ja_error_detection(inputs)
	if (locale === "hi") return hi_error_detection(inputs)
	if (locale === "pt-PT") return pt_pt2_error_detection(inputs)
	return en_error_detection(inputs)
});